export default __webpack_public_path__ + "static/media/from-clutter-2-cash-facebook-cover-banner.197f7833.jpg";